module.exports = __webpack_public_path__ + "img/football-ball.0f331994.svg";